module.exports = __webpack_public_path__ + "static/media/WhatIsMentalFitness.f609f28e.jpg";